import { render, staticRenderFns } from "./standard.vue?vue&type=template&id=1e40b21a&scoped=true"
import script from "./standard.vue?vue&type=script&lang=js"
export * from "./standard.vue?vue&type=script&lang=js"
import style0 from "./standard.vue?vue&type=style&index=0&id=1e40b21a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e40b21a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\CRMEB-JAVA-v2.4\\CRMEB-JAVA-v2.4\\single_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e40b21a')) {
      api.createRecord('1e40b21a', component.options)
    } else {
      api.reload('1e40b21a', component.options)
    }
    module.hot.accept("./standard.vue?vue&type=template&id=1e40b21a&scoped=true", function () {
      api.rerender('1e40b21a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ImagePicker/standard.vue"
export default component.exports